import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900">← Voltar</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-slate-900 mb-6">{title}</h1>
        <div className="prose-ap bg-white rounded-2xl border border-slate-200 p-8">
          {children}
        </div>
      </main>
    </div>
  );
}

export function TermsPage() {
  return (
    <LegalShell title="Termos de Uso">
      <p>Última atualização: {new Date().toLocaleDateString("pt-BR")}</p>
      <h2>1. Aceitação</h2>
      <p>Ao utilizar o AulaPronta, você concorda com estes Termos de Uso.</p>
      <h2>2. Serviço</h2>
      <p>O AulaPronta é uma plataforma de inteligência artificial para auxiliar professores da educação básica na criação de planos de aula, atividades, avaliações e aula completa.</p>
      <h2>3. Plano Gratuito</h2>
      <p>Todo novo usuário recebe 5 gerações gratuitas. Após o limite, é necessário assinar o plano Premium para continuar.</p>
      <h2>4. Plano Premium</h2>
      <p>O plano Premium custa R$ 19,90 por mês, cobrado de forma recorrente via Asaas (PIX ou cartão de crédito). O usuário pode cancelar a qualquer momento pelo painel do Asaas (link enviado em cada cobrança por e-mail).</p>
      <h2>5. Uso adequado</h2>
      <p>O conteúdo gerado deve ser revisado pelo professor antes de aplicação. O AulaPronta não se responsabiliza por imprecisões factuais do conteúdo gerado por IA.</p>
      <h2>6. Suporte</h2>
      <p>Dúvidas ou problemas: <a href="mailto:aulapronta01@gmail.com">aulapronta01@gmail.com</a> ou use a área Ajuda e Suporte dentro da plataforma.</p>
    </LegalShell>
  );
}

export function PrivacyPage() {
  return (
    <LegalShell title="Política de Privacidade">
      <p>Última atualização: {new Date().toLocaleDateString("pt-BR")}</p>
      <h2>1. Dados coletados</h2>
      <p>Coletamos: nome, e-mail, senha (armazenada apenas como hash), foto do Google (se login Google), materiais criados e informações mínimas necessárias para processamento da assinatura via Asaas (nome, e-mail e CPF/CNPJ).</p>
      <h2>2. Uso dos dados</h2>
      <p>Usamos seus dados exclusivamente para operar o AulaPronta, autenticar seu acesso, processar sua assinatura e enviar comunicações relacionadas à sua conta.</p>
      <h2>3. Compartilhamento</h2>
      <p>Compartilhamos dados apenas com: provedor de IA (para gerar o conteúdo que você solicita), Asaas (para processar pagamentos — PIX e cartão), Resend (para enviar e-mails de confirmação e suporte) e Meta/Facebook (Pixel + Conversions API para medição de desempenho dos nossos anúncios, com e-mail e identificador criptografados em SHA-256 antes do envio).</p>
      <h2>4. Dados de cartão</h2>
      <p>O AulaPronta não armazena dados de cartão. Todo o processamento é feito no Checkout seguro hospedado pelo Asaas (ambiente PCI-DSS).</p>
      <h2>5. Segurança</h2>
      <p>Senhas armazenadas com hash bcrypt. Tokens JWT com expiração. Comunicação via HTTPS. Segredos nunca expostos ao frontend.</p>
      <h2>6. Direitos do usuário</h2>
      <p>Você pode solicitar exclusão da sua conta e dados a qualquer momento pelo e-mail <a href="mailto:aulapronta01@gmail.com">aulapronta01@gmail.com</a>.</p>
    </LegalShell>
  );
}
